import React from "react";
import { AlertBox, AlertClose } from "./styles";
import { FiX } from "react-icons/fi";

type Props = {
  type?: "error" | "success" | "info";
  children: React.ReactNode;
  onClose?: () => void;
};

export default function InlineAlert({ type = "info", children, onClose }: Props) {
  return (
    <AlertBox $type={type}>
      <div>{children}</div>
      {onClose ? (
        <AlertClose type="button" onClick={onClose} aria-label="Fechar">
          <FiX />
        </AlertClose>
      ) : null}
    </AlertBox>
  );
}
